import React from "react";
import { Router, Route, Redirect, Switch } from "react-router-dom";
// import { createBrowserHistory } from "history";
import VideoPage from "./video-page/VideoPage";
import SignIn from "./sign-in-page/SignIn";
import Pricing from "./pricing-page/Pricing";
import Parents from "./parent-section/Parents";
import PublicBlogs from "./public-blogs/PublicBlogs";
import SettingsMain from "./settings/SettingsMain";
import EmailActivation from "./email-activation/EmailActivation";
import PwdResetMail from "./pwd-reset/PwdResetMail";
import PwdResetPassword from "./pwd-reset/PwdResetPassword";
import CharactersPage from "./characters-page/CharactersPage";
import Books from "./books-page/Books";
import AdminVideoPage from "./admin-page/AdminVideoPage";
import AdminBlogEntry from "./admin-page/AdminBlogEntry";
import Confirmation from "./confirmation-page/Confirmation";
import Story from "./parent-section/story-page/Story";
import "./App.css";
import { connect } from "react-redux";
import { closeSignUpModal } from "../actions/generalActions";
import { loggedInAndPremiumCheckUser } from "../actions/userActions";
import HomePagev2 from "./home-page-v2/HomePage";
// import local from '../api/local'
// const history = createBrowserHistory();
import history from "../config/history";
import Terms from "../legal/Terms";
import PrivacyPolicy from "../legal/PrivacyPolicy";
import AdminBlogPage from "./admin-page/AdminBlogPage";
import Unsubscribe from "./unsubscribe/Unsubscribe";
import PaymentIssueModal from "./modals/PaymentIssueModal";
import { openPaymentIssueModal } from "../actions/generalActions";
import AdminActivityPage from "./admin-page/AdminActivityPage";
import SampleStory from "./sample-pages/SampleStory";
import ReactGA from "react-ga4";
import ContactUs from "../legal/ContactUs";
import { Helmet } from "react-helmet";
import AdminPublicBlogPage from "./admin-page/AdminPublicBlogPage";
import AdminPublicBlogEntry from "./admin-page/AdminPublicBlogEntry";
import AdminUsersPage from "./admin-page/AdminUsersPage";
import Blog from "./public-blogs/blog/Blog";
class App extends React.Component {
  state = {
    isLoggedIn: false,
    isPremium: false,
  };

  async componentDidMount() {

    // initialize Google Analytics
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID)

    this.props.loggedInAndPremiumCheckUser();

  }

  componentWillUnmount() {
    this.unlistenGoogleAnalytics();
  }

  handleSignInClose = () => {
    this.setState({ signModalShow: false });
  };

  handleSignInOpen = () => {
    this.setState({ signModalShow: true });
  };

  render() {

    if (
      this.props.userStatus.isLoggedIn === undefined ||
      this.props.userStatus.loading
    ) {
      return null;
    }

    return (

      <>{/* Helmet for SEO Meta Tags and Structured Data */}
      <Helmet>
        <title>MeenduToons - Educational OTT for Kids</title>
        <meta
          name="description"
          content="Stream value-based educational videos for kids aged 3-8. Learn kindness, honesty, and more while having fun!"
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "MeenduToons",
              "url": "https://meendutoons.com",
              "logo": "https://meendutoons-static-bucket.s3.ap-south-1.amazonaws.com/imgs/logos/Main_logo__700_292.webp",
              "sameAs": [
                "https://www.facebook.com/meendutoons",
                "https://www.instagram.com/meendutoons"
              ]
            }
          `}
        </script>
      </Helmet>

      <div
        id="app"
        style={{ minHeight: "100%", position: "relative" }}
      >
        <SignIn
          signModalShow={this.props.showSignupModal}
          handleSignInClose={this.props.closeSignUpModal}
        />

        <PaymentIssueModal
          modalShow={this.props.showPaymentIssueModal}
          errMessage={this.props.paymentIssueModelContent}
        />

        <Router history={history}>
          <Switch>
            <Route
              path="/"
              exact
              component={() =>
                this.props.userStatus.isLoggedIn ? (
                  <Redirect to="/videos" />
                ) : (
                  <HomePagev2 handleSignInOpen={this.handleSignInOpen} />
                )
              }
            />
            <Route
              path="/2"
              exact
              component={() => (
                <HomePagev2 handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/videos"
              exact
              component={() => (
                <VideoPage handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/aboutus"
              exact
              component={() =>
                !this.props.userStatus?.isLoggedIn ? (
                  <Redirect to="/" />
                ) : (
                  <HomePagev2 handleSignInOpen={this.handleSignInOpen} />
                )
              }
            />
            <Route
              path="/pricing"
              exact
              component={() =>
                this.props.userStatus.isLoggedIn &&
                this.props.userStatus.isPremium ? (
                  <Redirect to="/videos" />
                ) : (
                  <Pricing handleSignInOpen={this.handleSignInOpen} />
                )
              }
            />
            <Route
              path="/activities"
              exact
              component={() => (
                <Parents handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/blogs"
              exact
              component={() => (
                <PublicBlogs handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/settings"
              exact
              component={() =>
                this.props.userStatus.isLoggedIn ? (
                  <SettingsMain handleSignInOpen={this.handleSignInOpen} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
            <Route
              path="/users/activate/:token"
              exact
              component={EmailActivation}
            />
            <Route path="/activities/story/:blogId" exact component={Story} />
            <Route path="/blogs/blog/:publicBlogId" exact component={Blog} />
            <Route
              path="/characters"
              exact
              component={() => (
                <CharactersPage handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/books"
              exact
              component={() => (
                <Books handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/confirmation/:page/:status"
              component={() => (
                <Confirmation handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/admins/videos"
              exact
              component={() => (
                <AdminVideoPage handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            {/* <Route
              path="/admins/blogs/new"
              exact
              component={() => (
                <AdminBlogEntry handleSignInOpen={this.handleSignInOpen} />
              )}
            /> */}
            <Route
              path="/admins/public-blogs"
              exact
              component={() => (
                <AdminPublicBlogPage handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            <Route
              path="/admins/public-blogs/new"
              exact
              component={() => (
                <AdminPublicBlogEntry handleSignInOpen={this.handleSignInOpen} />
              )}
            />

            <Route
              path="/admins/activities"
              exact
              component={() => (
                <AdminActivityPage handleSignInOpen={this.handleSignInOpen} />
              )}
            />

            <Route
              path="/admins/users"
              exact
              component={() => (
                <AdminUsersPage handleSignInOpen={this.handleSignInOpen} />
              )}
            />

            <Route
              path="/admins/blogs"
              exact
              component={() => (
                <AdminBlogPage handleSignInOpen={this.handleSignInOpen} />
              )}
            />
            {/* <Route
              path="/users/pwdReset/:token/:userId"
              exact
              component={PwdReset}
            /> */}
            <Route path="/users/pwdReset" exact component={PwdResetMail} />
            <Route
              path="/users/passwordReset/:token/:userId"
              exact
              component={PwdResetPassword}
            />
            <Route
              path="/users/unsubscribeDailyMail/:token/:userId"
              exact
              component={Unsubscribe}
            />
            <Route path="/terms" exact component={Terms} />
            <Route path="/privacy" exact component={PrivacyPolicy} />
            <Route path="/contactus" exact component={ContactUs} />
            <Route
              path="/samples/story/:blogId"
              exact
              component={SampleStory}
            />

            {/* Keep all routes above this route */}
            <Route
              path="*"
              exact
              render={({ location }) =>
                location.pathname !== "/" && <Redirect to="/" />
              }
            />
          </Switch>
        </Router>
      </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showSignupModal: state.general.showSignupModal,
    userStatus: state.userLoggedinAndPremiumCheck,
    showPaymentIssueModal: state.general.showPaymentIssueModal,
    paymentIssueModelContent: state.general.paymentIssueModelContent,
  };
};

export default connect(mapStateToProps, {
  closeSignUpModal,
  loggedInAndPremiumCheckUser,
  openPaymentIssueModal,
})(App);
